// const ApiRootUrl = 'http://localhost:5002/api/v1/';

export default {
  JsApiConfig: "api/v1/weixin-module/js-api",
  Page: {
    Index: "/api/mall-fit-up/index-mini-page-by-identity-type",
    GetSubscriptList:"/api/mall-subscript/GetSubscriptList"
  },
  Cart: {
    Delete: "/api/v1/cart-module/deleteBasket",
    Get: "/api/v1/cart-module/basket",
    GetNO: "/api/v1/cart-module/basketNum",
    UpdateNO: "/api/v1/cart-module/basketNumber",
    Status: "Basket/Item/CheckedStatus",
    Update: "basketservice-api/api/v1/Basket",
    Checked: "/api/v1/cart-module/basketChecked",
    AllChecked: "/api/v1/cart-module/basketAllChecked",
    PayCheckout: "/api/v1/order-module/checkout",
    EmpltyDeleted: "/api/v1/cart-module/EmpltyDeleted",
    CleanInvalidGoods:"/api/v1/cart-module/CleanInvalidGoods",
    CartActivity:"/api/v1/order-module/CheckoutPackageCheck"
  },
  Group: {
    Get: "/goodsservice-api/api/v1/GoodsGroup/goodsGroup",
    Child: {
      Get: "goodsservice-api/api/v1/GoodsGroup/GoodGroupItemList",
      Nest: {
        Get: "WxGoodsGroup/GoodsCategoryInfo/",
      },
      Item: {
        Get: "goodsservice-api/api/v1/GoodsGroup/GoodGroupItemListByChildCode",
      },
    },
  },
  EmployeePage: {
    Upload: "api/mall-user/upload-employee-image",
    Post: "/api/mall-user/register-employee",
    ShareCode: "/api/mall-user/employee-by-share-code",
    List: "employee/api/v1/Employee/Balance/Records",
    Balance: "employee/api/v1/Employee/Balance",
    AddNewUser: "/api/mall-user/bind-share-code",
    BindUser: "/api/mall-user/bind-phone-number-and-share-code",
    Agreed: "/api/mall-user/set-employee-agreed",
    Disagreed: "/api/mall-user/set-employee-disagreed",
    PercentageList: "/api/mall-user/owner-percentage-list",
    ownerBalance: "/api/mall-user/owner-balance-record",
    userByShareCode:'api/mall-user/user-by-share-code',
    bindShareCodeForUser:'/api/mall-user/bind-share-code-for-user',
    bindPhoneNumberAndShareCodeForUser:'/api/mall-user/bind-phone-number-and-share-code-for-user'
  },
  Goods: {
    Get: "/api/v1/goods-module/goods",
    AddBasket: "/api/v1/cart-module/addBasket",
    GetByName: "/api/v1/GoodsDetailPage/GoodListByName",
    Marketing: 'GoodsDetailPage/Marketing',
    Coupon: 'coupon/api/v1/coupon',
    GetLimitGoodsDetail:'/api/v1/goods-module/GetLimitGoodsDetails',
    GetSharePicture:'/api/v1/goods-module/goods-img',
    GetUserImg:'api/mall-user/user-img'
  },
  Mini: {
    Get: "/api/mall-fit-up/index-mini-module-by-id",
  },
  Address: {
    Post: "/api/mall-user/user-address",
    Get: "/api/mall-user/user-address-list",
    Detail: "/api/mall-user/user-address-detail",
    Put: "/api/mall-user/user-address",
    Delete: "/api/mall-user/user-address",
    getDefault: "/api/mall-user/user-address-default",
  },
  partnerList: {
    Get: "/api/mall-user/is-owner-talent",
    List: "/api/mall-user/owner-talent-list"
  },
  User: {
    Post: "/api/v1/order-module/checkout",
    GetAvatar: "/api/mall-user/user-avatar-url",
    Get: "api/v1/Employee",
    Balance: "/api/mall-user/owner-balance",
    UserStock: "/api/mall-user/check-stock",
    EmployeeNum: "/api/mall-user/check-employee-stock",
    GuaranteeNumber: "/api/mall-user/GetGuaranteeNumber",
    Chat: '/api/v1/mes-module/UpdateMesStatus',
    Chatlist: '/api/v1/mes-module/GetMesList',
    ChatDetail: '/api/v1/mes-module/GetMesById',
    ChatStatus: '/api/v1/mes-module/CheckMes',
    ChatGetMesNum: '/api/v1/mes-module/GetMesNum',
    GoodsCodeNum: '/api/mall-pcode/mall-p-code',
    EmployeeIsCanBuy: '/api/v1/order-module/checkEmployeeCanBuy',
    EmployeeCode: '/api/mall-user/mall-p-code',
    like: '/api/mall-user/GetSuperiorLeaders',
    IsCanRevocation: '/api/mall-user/is-can-revocation-apply',
    RevocationApply: 'api/mall-user/revocation-apply',
    UserScore:'api/mall-user/user-score',
    integralLogin:'api/mall-user/integral-login',
    IsCanRegister:'api/mall-user/is-can-register-employee',
    GetPCodeByPage:'api/mall-pcode/GetPCodeByPage',
    ManualClaim:'api/mall-pcode/ManualClaim',
    unReadMessageCount:'/api/mall-user/un-read-message-count',
    applyCount:'/api/mall-user/apply-count',
    InvitationQuantity:'/api/mall-user/invitation-quantity',
    GetOrderCode:"/api/mall-user/GetUserOrderCode",
    canApplyPartner: "api/mall-user/can-apply-partner",
    applyUpgradePartner:"api/mall-user/apply-upgrade-partner",
    CanBeSale:"api/mall-sale/CanBeSale",
    CheckUserCanBeSale:"api/mall-sale/CheckUserCanBeSale",
    GetSalesApprovalQuantity:"api/v1/sale-module/GetSalesApprovalQuantity",
    GetSalesUpgradePartnerApprovalQuantity:"api/mall-user/GetSalesUpgradePartnerApprovalQuantity"
  },
  Follow: {
    List: "api/mall-user/user-subscription-info",
    followPageList:"api/mall-user/paged-user-subscription-info",
    getCode: "api/mall-user/user-p-code",
    pCodeDetail: "api/mall-user/user-p-code-info",
    pCodePageList:"api/mall-user/paged-user-p-code-info"
  },
  Coupons: {
    Get: "user/api/v1/assets/coupon/list",
    checkoutGet: "user/api/v1/assets/coupon/list",
    CouponGet: "User/Coupon/Goods",

  },
  Checkout: {
    Get: "/api/v1/order-module/getcheckout",
    GetCheckOutPage: "/api/v1/BasketPage/GetCheckOutPage",
    post: "api/v1/CheckoutPage",
    purchase: "/api/v1/order-module/checkout",
    shopShare:'/api/v1/order-module/checkout',
    purchaseCart: "/api/v1/order-module/checkout",
    GetDefaultCoupon: "userservice-api/api/v1/Assets/Coupon",
    GetCouponPrice: "couponservice-api/api/v1/Coupon/GoodsPrice",
    GetBasketCheckout: "/api/v1/order-module/getcart",
    GetActiveText:"/api/mall-fit-up/index-mini-page-by-title",
    GetShareList:'/api/v1/order-module/getcheckout'
  },

  order: {
    List: "/api/v1/order-module/orders",
    Detail: "/api/v1/order-module/detail",
    Cancel: "/api/v1/order-module/cancel",
    Refund: "/api/v1/order-module/refund",
    OnRefund: "/api/v1/mall-refund/RefundOrder",
    RefundOrderList: "/api/v1/order-module/RefundOrderList",
    Post: "/api/v1/order-module/checkout",
    expressDetail: "/api/v1/express-module/express-detail",
    CheckOrderExpire: "/api/v1/order-module/CheckOrderExpire"
  },
  Payment: {
    Wxpay: {
      UnifiedOrder: "/api/v1/order-module/unified-order",
      QueryOrder: "WxPay/QueryOrder",
    },
  },
  Package: {
    Get: "/api/v1/goods-module/package-by-id",
    Post: "/api/v1/order-module/checkout",
    List: "/api/v1/goods-module/package"
  },
  UserCenterPage: {
    GetUnPaidOrder: "/api/v1/order-module/unpaid",
    PutRefreshUnionId: "UserCenterPage/RefreshUnionId",
    GetEmployee: "/api/mall-user/employee-by-share-code",
    QrCode: "/api/mall-user/employee-share-code-url",
    Quantity: "/api/mall-user/employee-quantity",
    List: "/api/mall-user/employees",
    Detail: "/api/mall-user/employee-by-employee-id",
    userShareCodeUrl:"/api/mall-user/user-share-code-url   "
  },
  Setting: {
    SettingPhone: "/api/mall-user/bind-phone-number",
    SettingCode: "/api/mall-user/bind-share-code",
    Sms: "/api/v1/sms-module/send-sms-code",
    Get: "/api/v1/weixin-module/sms-code",
    CodeNum: "/api/mall-pcode/p-code-num",
    WXCode: "api/mall-user/change-wx-code",
    IDCard: "api/mall-user/change-wx-code-by-id-card",
    GetUserInfo:"api/mall-user/GetUserInfo",
    UpdateUserName:"api/mall-user/UpdateUserName",
    UploadUserImage:"api/mall-user/UploadUserImage"
  },
  WxUserInfo: {
    Get: "/api/mall-user/login-user-by-code",
    LoginCheckBind:"/api/mall-user/LoginCheckUserIsBind",
    TestGet: "api/mall-user/user-by-open-id",
    GetStatus: "userservice-api/api/v1/User",
    Debugger: "api/mall-user/CheckDebugger",
    ScanRecord:"api/mall-user/scan-record",
    PackageDetail:"/api/mall-user/GetGiftPackageDetail"
  },
  bank: {
    Get: "/api/mall-user/user-bank-card",
    GetCard: "/api/mall-user/user-bank-card-number",
    GetStatus: "/api/mall-user/is-card-pass",
    GetReject: "api/mall-user/card-no-pass",
    UpdateReject: "/api/mall-user/edit-card-no-pass-message-stauts",
    Post: "/api/mall-user/bank-card",
    Put: "api/mall-user/unbind-bank-card"
  },
  Invitation: {
    Register: "EmployeeRegisterPage",
    List: "/api/mall-user/GetGuaranteeList",
    Update: "/api/mall-user/UpdateGuarantee"
  },
  MyShare: {
    List: "/api/mall-user/service-person-list",
    Detail: "/api/v1/order-module/order-item-detail-list",
    GetDate: "/api/mall-user/date",
    Post: "/api/mall-user/customer-maintenance",
    customerList:'/api/mall-user/service-person-by-customer-list',
    statisticsList:"/api/mall-user/statistics-list",
    agentDetail:"/api/v1/order-module/agent-order-item-detail-list",
    DateForEmployee:"/api/mall-user/date-for-employee",
    ServicePersonForEmployeeList:"/api/mall-user/service-person-for-employee-list",
    AccountList: "/api/mall-user/account-list",
    switchAccounServicePersonList:'api/mall-user/switch-accoun-service-person-list',
    switchAccounForEmployeeList:'/api/mall-user/switch-accoun-for-employee-list',
    isShowSwitch:'/api/mall-user/is-show-switch'
  },
  Superior: {
    Get: "/api/mall-user/service-person-picture",
    GetBusinessCard: "/api/mall-user/business-card",
    Upload: "api/mall-user/upload-business-card"
  },
  Agent: {
    GetNickName: "/api/mall-user/agent-nick-name-list",
    GetAddress: "/api/mall-user/agent-adress-list",
    GetDetail:"/api/mall-user/agent-adress/",
    addGroupInfo: "/api/mall-user/agent-info",
    addAddress: "/api/mall-user/agent-address",
    DeleteAddress: "/api/mall-user/agent-address",
    DeleteNickName: "/api/mall-user/agent",
    EditNickName: "/api/mall-user/agent-nick-name",
    EditNEditAddress: "/api/mall-user/agent-address"
  },

  MallIndex: {
    List: "api/v1/score-module/GetScopeGoodsList",
  },
  MallCenter: {
    Get: "/api/v1/score-module/GetUserInfo"
  },
  MallDetail: {
    Detail: "api/v1/score-module/GetScopeGoodsDetail",
  },
  MallPurchase: {
    Post: "api/v1/score-module/GetScoreCheckOut",
    CheckOut: "api/v1/score-module/ScoreCheckOut"
  },
  Mallintegral: {
    GetIntegral: "api/v1/score-module/GetUserScoreFlow",
  },
  MallOrder: {
    List: "/api/v1/score-module/orders",
    Detail: "/api/v1/score-module/detail",
  },
  Apply:{
    apllyQualification: "/api/mall-user/aplly-qualification",
    applicationList:"/api/mall-user/application-list",
    changeUnReadMessageStatus:'/api/mall-user/change-un-read-message-status',
    sixMonths:'/api/mall-user/six-months',
    paymentForGoodsToOwner:'/api/mall-user/payment-for-goods-to-owner',
    agentToOwner:'/api/mall-user/agent-to-owner',
    processList:'/api/mall-user/process-list',
    applyCount:'/api/mall-user/apply-count',
    processApply:'/api/mall-user/process-apply',
    companyToOwner:'/api/mall-user/company-to-owner',
    tenYears:'/api/mall-user/ten-years'
  },
  Hire:{
    userEmployList:"/api/mall-user/user-employ-list",
    employmentRecordList:'/api/mall-user/employment-record-list',
    invitationEmploy:'/api/mall-user/invitation-employ',
    employInvitationList:'/api/mall-user/employ-invitation-list',
    employStatus:'/api/mall-user/employ-status'
  },
  Maintenance:{
    userMaintenance:"/api/mall-user/user-maintenance",
    applyChangeService:"/api/mall-user/apply-change-service",
    getApplyRecordList:"/api/mall-user/GetApplyRecordList",
    getMaintenanceList:"/api/mall-user/GetMaintenanceList",
    rejectMaintenance:"/api/mall-user/RejectMaintenance",
    getMaintenanceCount:"/api/mall-user/GetMaintenanceCount",
  },
  Sale:{
    ConfirmSale:"api/mall-sale/ConfirmSale",
    GetSalesApprovalsByStatus:"api/v1/sale-module/GetSalesApprovalsByStatus",
    GetSalesRecord:"api/v1/sale-module/GetSalesRecord",
    GetMySalesRecord:"api/v1/sale-module/GetMySalesRecord",
    GetDateByMonthNum:"api/mall-user/GetDateByMonthNum",
  },
  OwnerApply:{
    ManagerConfirmation:"api/mall-user/store-manager-confirmation",
    GetSalePartnerApprovals:"api/mall-user/GetSaleUpgradePartnerApprovalsByStatus",
  },
  OwnerApproval:{
    GetUserApprovals:"api/mall-user/GetUserSaleUpgradePartnerApprovalsByStatus",
  },
  Approval:{
    GetUserSalesApprovalsByStatus: "api/v1/sale-module/GetUserSalesApprovalsByStatus"
  },
  MerchantVerification:{
    GetCheck: "api/mall-user/check-user-store-qualification",
    Get: "api/mall-user/user-store-qualification",
    Post: "api/mall-user/input-user-store-qualification"
  },
};